import { fetchYourTitlesProducts } from './fetchYourTitlesProducts';
import { useQuery } from '@tanstack/react-query';
import { Pagination } from '../../../../models/Pagination';
import { browserClient } from '../../../react-query';
import { GlobalReactQueryOptions } from '../../../config';
import { ProductFilter } from '../../../store/api';

export const LOCAL_CONTENT_YOUR_TITLES_PRODUCT_QUERY_KEY = 'localContentYourTitlesProduct';

interface Params {
    pagination: Pagination;
    filterMap: ProductFilter;
}
export const useYourTitlesProducts = ({ filterMap, pagination }: Params) => {
    const { ...data } = useQuery(
        [LOCAL_CONTENT_YOUR_TITLES_PRODUCT_QUERY_KEY, { filterMap, ...pagination }],
        () => fetchYourTitlesProducts({ pagination, filterMap }),
        { ...GlobalReactQueryOptions }
    );
    const { data: yourTitlesProducts } = data;
    return {
        ...data,
        products: {
            count: yourTitlesProducts?.totalHits ?? 0,
            list: yourTitlesProducts?.hits ?? []
        }
    };
};

export const invalidateYourTitlesProducts = () => {
    return browserClient.invalidateQueries({ queryKey: [LOCAL_CONTENT_YOUR_TITLES_PRODUCT_QUERY_KEY] });
};
